$(function(){
	'use strict';
	
	//---------------------------------------
	// 初期値設定
	//---------------------------------------
	var intPivot = 0;
	var intFollowPivot = 0;
	//------------------
	// 各種要素設定
	//------------------
	// PCヘッダー
	var headerPc = $('#shopify-section-header');
	// todo:SPヘッダー
	var headerSp = $('#header_sp');

	//------------------
	// 固定しているヘッダー縦幅（バーまでの距離）を指定
    // ※それぞれのバーまでの距離がわかる要素のセレクタを指定
    // ※最上部からの要素でないと、当該要素の「現在の位置＋当該要素の高さ」で下端を計算した場合、
    // 追従時からページが始まった際にmargin-top分誤差が出るので注意
	//------------------
	// PC
	var headerPcBefore = $('h1');
	// PC
	var headerSpBefore = $('h1');
	
	// PC
	var intPcKyori = $(headerPcBefore).offset().top + $(headerPcBefore).outerHeight();
	// スマホ
	var intSpKyori = $(headerSpBefore).offset().top + $(headerSpBefore).outerHeight();
	
	//------------------
	// 追従バーの厚み
    // todo:追従バーの厚みを設定
    //------------------
	// PC
	var intPcBar = 137;
	// SP
	var intSpBar = 91;
	
	//------------------
	// メニュー切り替えポイント
	//------------------
	var intMenuChangePoint = 1024;
	
	//------------------
	// 現在のバー高さと対象ヘッダーを記憶
	//------------------
    var targetHeader = '';
    var intBarHeight = 0;
	if ( window.innerWidth < intMenuChangePoint ) {
		// スマホ時
        targetHeader = $(headerSp);
		intBarHeight = intSpBar;
	} else {
		// PC時
        targetHeader = $(headerPc);
		intBarHeight = intPcBar;
	}
	
    // 初回のヘッダーを記憶
    var beforeTargetHeader = $(targetHeader);
	
	//---------------------------------------
	// スムーズスクロール処理
	//---------------------------------------
	$('a[href^="#"]').click(function() {
	// スクロールの速度
	var speed = 400; // ミリ秒
	// アンカーの値取得
	var href= $(this).attr("href");
	// 移動先を取得
	var target = $(href == "#" || href == "" ? 'html' : href);
	// 移動先を数値で取得
	var position = target.offset().top;
	//------------------
	// メニューバー分をマイナス
	//------------------
	// PC・スマホそれぞれ、追跡するバー分を引く
	position -= intBarHeight;
		
	// 指定位置までスムーズスクロール
	$('body,html').animate(	
								{
									scrollTop:position
								}, 
								{
									duration: speed ,
									easing : 'swing' ,
									complete: function() {
									}
								}
							);
      return false;
   });
    
	//---------------------------------------
	// 初期表示
	//---------------------------------------
	// 基準値
	// ※固定しているヘッダー縦幅（バーまでの距離）を指定
	if ( window.innerWidth >= intMenuChangePoint ) {
		// PC時
		intPivot = intPcKyori;
	} else {
		// スマホ時
		intPivot = intSpKyori;
	}
	
	if( $(window).scrollTop()>=intPivot ) {
		// 基準値以上スクロールされているなら、表示

		//------------------
		// ボタン制御
		//------------------
		// トップに戻るボタンを表示
		//topBtn.fadeIn();
		
		//------------------
		// ヘッダー制御
		//------------------
        // ヘッダーを追跡
        $(targetHeader).addClass('fixedHeader');
        // fixされて消えたメニューバー分の厚みをマージンとして付与
        $('html').css('margin-top' , intBarHeight );
	} else {
		// 基準値未満なら、非表示
		
		//------------------
		// ボタン制御
		//------------------
		// トップに戻るボタンを隠す
		//topBtn.hide();
		
        //------------------
        // ヘッダー制御
        //------------------
		// 付与していたメニューバー分のマージンを解除
		$('html').css('margin-top' , '0' );
        // ヘッダーの追跡を解除追跡
        $(targetHeader).removeClass('fixedHeader');
	}
	
	//---------------------------------------
	// スクロールイベント
	//---------------------------------------
	$(window).scroll(function(){
		if( $(window).scrollTop()>=intPivot ) {
			// 基準値以上スクロールされているなら、表示

			//------------------
			// ボタン制御
			//------------------
			// トップに戻るボタンを表示
			//topBtn.fadeIn();
			
            //------------------
            // ヘッダー制御
            //------------------
            // ヘッダーを追跡
            $(targetHeader).addClass('fixedHeader');
            // fixされて消えたメニューバー分の厚みをマージンとして付与
            $('html').css('margin-top' , intBarHeight );


		} else {
			// 基準値未満なら、非表示
			
			//------------------
			// ボタン制御
			//------------------
			// トップに戻るボタンを隠す
			//topBtn.hide();
			
            //------------------
            // ヘッダー制御
            //------------------
            // 付与していたメニューバー分のマージンを解除
            $('html').css('margin-top' , '0' );
            // ヘッダーの追跡を解除追跡
            $(targetHeader).removeClass('fixedHeader');
		}
	});
	
	//------------------
	// リサイズ完了イベント
	//------------------
	var timer = false;
	$(window).resize(function() {
		if (timer !== false) {
			clearTimeout(timer);
		}
		timer = setTimeout(function() {
            //------------------
			// 基準値再計算
			// ※固定しているヘッダー縦幅を再計算
            //------------------
			// PC
			intPcKyori = $(headerPcBefore).offset().top + $(headerPcBefore).outerHeight();
			// スマホ
			intSpKyori = $(headerSpBefore).offset().top + $(headerSpBefore).outerHeight();
		
			if ( window.innerWidth >= intMenuChangePoint ) {
				// PC時
				intPivot = intPcKyori;
			} else {
				// スマホ時
				intPivot = intSpKyori;
			}
					
            //------------------
            // 現在のバー高さと対象ヘッダーを再計算
            //------------------
            if ( window.innerWidth < intMenuChangePoint ) {
                // スマホ時
                targetHeader = $(headerSp);
                intBarHeight = intSpBar;
            } else {
                // PC時
                targetHeader = $(headerPc);
                intBarHeight = intPcBar;
            }

            // 新たなheaderを記憶
            beforeTargetHeader = targetHeader;

			if( $(window).scrollTop()>=intPivot ) {
				// 基準値以上スクロールされているなら、表示

				//------------------
				// ボタン制御
				//------------------
				// トップに戻るボタンを表示
				//topBtn.fadeIn();

                //------------------
                // ヘッダー制御
                //------------------
                // ヘッダーを追跡
                $(targetHeader).addClass('fixedHeader');
                // fixされて消えたメニューバー分の厚みをマージンとして付与
                $('html').css('margin-top' , intBarHeight );

			} else {
				// 基準値未満なら、非表示
				
				//------------------
				// ボタン制御
				//------------------
				// トップに戻るボタンを隠す
				//topBtn.hide();
				
                
                //------------------
                // ヘッダー制御
                //------------------                
				// 付与していたメニューバー分のマージンを解除
				$('html').css('margin-top' , '0' );
				$(targetHeader).removeClass('fixedHeader');
			}
		}, 200);
	});
});